import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class GetSignatureServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 通过人员id查询 签名信息
  public getStaffSignatureByStaffId(id: any) {
    const url = serverUrl + `/api/spaceManage/staffSignature/byStaffId/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
}
